import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import * as InventoryTag from '../../../sharedComponents/inventoryTags/InventoryTag';
import { formatMoney } from '../../../../helpers/moneyHelper';

const propTypes = {
    reservation: PropTypes.shape({
        order_details: PropTypes.shape({
            tour_date: PropTypes.string,
            tour_start: PropTypes.string,
            tour_end: PropTypes.string,
            description: PropTypes.string,
            recarea: PropTypes.string,
            location: PropTypes.string
        }),
        subtotal: PropTypes.string,
        quantity: PropTypes.string
    }).isRequired
};

export class DefaultInventoryComponent extends React.PureComponent {
    render() {
        const res = this.props.reservation;
        const tourDate = moment.utc(res.order_details.tour_date).format('MMMM DD, YYYY');

        return (
            <div className="rec-order-confirmation-reservation">
                <div className="rec-order-confirmation-reservation-column">
                    <div className="rec-order-confirmation-reservation-dates">
                        <p className="strong">Tour Date: {tourDate}</p>
                        <p>Tour Start: {res.order_details.tour_start}</p>
                        <p>Tour End: {res.order_details.tour_end}</p>
                    </div>
                </div>
                <div className="rec-order-confirmation-reservation-column">
                    <div className="rec-order-confirmation-reservation-icon">
                        <InventoryTag.InventoryTicket isSpanItem />
                    </div>
                    <div className="rec-order-confirmation-reservation-description">
                        <p className="strong">{res.order_details.description}</p>
                        <p><i>{res.order_details.recarea}</i></p>
                        <p>{res.order_details.location}</p>
                    </div>
                </div>
                <div className="rec-order-confirmation-reservation-column">
                    <div className="rec-order-confirmation-reservation-total">
                        <p>Subtotal: <strong>{formatMoney(res.subtotal)}</strong></p>
                        <p>Quantity: <strong>{res.quantity} Ticket(s)</strong></p>
                    </div>
                </div>
            </div>
        );
    }
}

DefaultInventoryComponent.propTypes = propTypes;

export default DefaultInventoryComponent;
